import React from 'react'
import { useTranslation } from 'react-i18next'

import { InfoItem } from '../InfoItem'
import { FlagLocked } from '../FlagLocked'
import { formatKemCardInfos } from '../InfoItem/utils/formatKemCardInfos'
import { BaseView, BaseText } from '@/components/base'
import { Separator } from '@/components/Separator'
import { useUserStore } from '@/store/useUserStore'
import { links } from '@/constants/links'

interface DetailInfosProps {
  containerStyle?: React.CSSProperties
}

export const DetailInfos: React.FC<DetailInfosProps> = ({ containerStyle }) => {
  const { t } = useTranslation()

  const wallet = useUserStore((state) => state.wallet)
  const userAuthenticated = useUserStore((state) => state.userAuthenticated)

  // Check if card exists and get its status
  const hasKemCard = wallet?.cards && wallet.cards.length > 0
  const kemCardState = wallet?.cards?.[0]?.state
  const kemCardOwnerName = userAuthenticated
    ? `${userAuthenticated.first_name} ${userAuthenticated.last_name}`
    : null

  const formattedKemCardInfos = formatKemCardInfos(t)
  const isLocked = kemCardState !== 'active'

  const InfoItemWithSeparators: React.FC<{
    title: string
    value?: string
    valueComponent?: () => React.ReactNode
    isFirstItem?: boolean
  }> = ({ title, value, valueComponent, isFirstItem = false }) => (
    <BaseView pt={6}>
      {isFirstItem && <Separator />}
      <BaseView py={12}>
        <InfoItem title={title} value={value} valueComponent={valueComponent} />
      </BaseView>
      <Separator />
    </BaseView>
  )

  return (
    <BaseView style={containerStyle} className="pb-[46px]">
      {/* Card owner name */}
      {hasKemCard && kemCardOwnerName && (
        <InfoItemWithSeparators
          isFirstItem
          title={t('translation:name')}
          value={kemCardOwnerName}
        />
      )}

      {/* Card status if locked */}
      {hasKemCard && isLocked && (
        <InfoItemWithSeparators
          title={t('translation:status')}
          valueComponent={() => <FlagLocked fontSize={16} />}
        />
      )}

      <BaseView py={16}>
        {/* Fee information */}
        {formattedKemCardInfos.map(({ title, id, value }) => (
          <InfoItem key={id} title={title} value={value} />
        ))}
      </BaseView>

      <Separator />
      <BaseView py={20}>
        {/* Additional card information */}
        {hasKemCard && (
          <BaseView>
            {/* <BaseText
              fontSize={14}
              fontFamily="regular"
              color="label.description"
              style={{ marginBottom: 8 }}
            >
              *
              {t(
                'kemCard.theAvailableCardIs',
                'The available currency for the card is',
              )}{' '}
              USDT
            </BaseText> */}
            <BaseText fontSize={14} fontFamily="regular">
              *
              {t(
                'screens:kemCard.detailInfos.noOverdraft',
                'No overdraft/credit feature',
              )}
            </BaseText>
          </BaseView>
        )}
      </BaseView>
      <Separator />
      <BaseView py={16}>
        {/* Financial institution information */}
        <BaseView style={{ paddingTop: hasKemCard ? 0 : 24 }}>
          <InfoItem
            title={t('translation:financialInstitution')}
            value="Interlace"
            valueIsLink
            onClickLink={() => {
              window.open(links.interlaceTerms, '_blank')
            }}
          />
          <InfoItem
            title={t('translation:program')}
            value={t(
              'screens:kemCard.detailInfos.kemProgram',
              'Kem Prepaid Card Program',
            )}
          />
        </BaseView>
      </BaseView>
      <Separator />
    </BaseView>
  )
}
